import gql from 'graphql-tag';

import dokkioErrorFragment from './dokkioErrorFragment';

export const shareRemoteItemResultFragment = gql`
  fragment shareRemoteItemResultFragment on ShareRemoteItemResult {
    dokkioClass
    remotePermissionWarning {
      ...dokkioErrorFragment
    }
  }
  ${dokkioErrorFragment}
`;
export default shareRemoteItemResultFragment;
